import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=80adaad0"
import script from "./TemplateTable.vue?vue&type=script&lang=ts"
export * from "./TemplateTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports